function customreg() {

    var code = getUrlParam('rcode');
    if ( code ) {
        createCookie('register', code, 1);
    }

}
